import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import 'jquery-match-height';
import 'lity';
import './home.js';
import './works.js';

jQuery(function ($) {

	// smooth scroll
	$(function () {
		var headerHeight = 0;
		$('a[href^="#"]').click(function() {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
			return false;
		});
	});

  // SP nav
	$(function () {
		if (window.matchMedia("(max-width: 767px)").matches) {
			$('.js-nav-bt').on('click', function () {
				if ($('.js-nav-content').hasClass('is_open')) {
					$(".js-nav-content").removeClass('is_open');
					$(".header__bg").removeClass('is_open');
					$(this).removeClass('is_open');
				} else {
					$(".js-nav-content").addClass('is_open');
					$(".header__bg").addClass('is_open');
					$(this).addClass('is_open');
				}
			});
			$('.js-nav-bt.is_open, .header__bg').on('click', function () {
				$(".js-nav-content, .js-nav-bt.is_open, .header__bg.is_open").removeClass('is_open');
			});
		} else {
			$('.js-nav-parent').on('mouseenter', function(){
				$(this).addClass('is_active');
				$(this).find('.js-nav-child').addClass('is_active');
			});
			$('.js-nav-parent').on('mouseleave', function(){
				$(this).removeClass('is_active');
				$(this).find('.js-nav-child').removeClass('is_active');
			});
		}
	});

	// pull down
  $(function(){
    $('.js-matchheight').matchHeight();
  });

});
